const todo = {
  id: null,
  name: null,
  description: null,
  linkUrl: null,
  todoGroupId: null,
  todoGroupName: null,
  assignedToUserId: null,
  targetDate: null,
  complete: null,
  completedAt: null,
  completedBy: null,
  createdBy: null,
  updatedBy: null,
  createdAt: null,
  updatedAt: null
}

export default () => Object.assign({}, todo)
